import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { getTeacherSubjects, uploadDocument, formatApiError } from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { BookOpen, Users, Calendar, Clock, Video } from 'lucide-react';

export default function TeacherCourses() {
  const navigate = useNavigate();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try { setSubjects(await getTeacherSubjects()); }
      catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    fetch();
  }, []);

  if (loading) return <Layout><div className="p-6 md:p-8 flex items-center justify-center min-h-[60vh]"><div className="spinner" /></div></Layout>;

  return (
    <Layout>
      <div className="p-6 md:p-8" data-testid="teacher-courses-page">
        <div className="mb-8">
          <h1 className="font-heading text-2xl sm:text-3xl lg:text-4xl tracking-tight font-medium text-[#1A1A1A]">Mis Cursos Asignados</h1>
          <p className="text-[#737373] mt-2">Gestiona las clases de tus cursos asignados</p>
        </div>

        {subjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subjects.map((sub) => (
              <Card key={sub.id} data-testid={`subject-card-${sub.id}`} className="bg-white border border-[#E5DFD3] shadow-sm course-card">
                <CardHeader>
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="text-xs text-[#8B1538] font-medium mb-1">{sub.module_title}</p>
                      <CardTitle className="font-heading text-lg text-[#1A1A1A]">{sub.title}</CardTitle>
                    </div>
                    <div className="h-8 w-8 rounded-full bg-[#8B1538] text-white flex items-center justify-center text-xs font-bold">{sub.order}</div>
                  </div>
                </CardHeader>
                <CardContent className="space-y-3">
                  {sub.description && <p className="text-sm text-[#4A4A4A] line-clamp-2">{sub.description}</p>}
                  <div className="flex flex-wrap gap-3 text-sm text-[#737373]">
                    <span className="flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {sub.duration_weeks} semanas</span>
                    <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {sub.classes_per_week} clase/sem</span>
                    <span className="flex items-center gap-1"><Video className="h-3.5 w-3.5" /> {sub.classes_count} clases</span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <BookOpen className="h-16 w-16 mx-auto text-[#D9B48F] mb-4" />
            <h3 className="font-heading text-xl text-[#1A1A1A] mb-2">No tienes cursos asignados</h3>
            <p className="text-[#737373]">El administrador te asignará cursos para gestionar</p>
          </div>
        )}
      </div>
    </Layout>
  );
}
